import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { map, catchError } from 'rxjs/operators';
import { domain } from 'src/environments/environment';
import { GlobalProvider } from './global';
import { ToastController } from '@ionic/angular';

console.log('domain',domain)
@Injectable({
  providedIn: 'root',
})
export class AuthService {
  constructor(private http: HttpClient, private g: GlobalProvider, private toastController: ToastController) {}
  getHeader = () => {
    return {
      headers: new HttpHeaders({
        Authorization: this.g.jws,
      }),
    };
  };

  login(username:any, password:any) {
    const httpOptions = {
      headers: new HttpHeaders({
        // Authorization: this.jws ? this.jws : ''
      }),
    };
    const url = `${domain}/access/login`;
    const data = { username, password };
    return this.http.post(url, { data }, httpOptions).pipe(
      map((results) => results),
      catchError((error) => {
        console.log('login', error);
        // error(error);
        this.presentToast('Invalid username or password', 'danger'); 
        throw error;
      })
    );
  }

  async loginViaToken(jws:any) {
    const httpOptions = {
      headers: new HttpHeaders({
        Authorization: jws,
      }),
    };
    const url = `${domain}/access/profile`;
    return this.http.get(url, httpOptions).pipe(
      map((results) => {
        console.log('loginViaToken return ok', results);
        return results;
      }),
      catchError((error) => {
        // console.log('loginViaToken', error);
        throw error;
      })
    );
  }

  
  async presentToast(message: string, color: string) {
    const toast = await this.toastController.create({
      message: message,
      color: color,
      duration: 2000
    });
    toast.present();
  }
}
